
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"40","height":"40","rx":"20","fill":"#EAEDF2"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.25 11H26V8.375A.403.403 0 0025.625 8h-.75a.37.37 0 00-.375.375V11h-9V8.375A.403.403 0 0015.125 8h-.75a.37.37 0 00-.375.375V11h-2.25a2.25 2.25 0 00-2.25 2.25v16.5c0 1.266.984 2.25 2.25 2.25h16.5a2.25 2.25 0 002.25-2.25v-16.5c0-1.219-1.031-2.25-2.25-2.25zM29 29.75c0 .422-.375.75-.75.75h-16.5a.74.74 0 01-.75-.75V17h18v12.75zM11 15.5h18v-2.25c0-.375-.375-.75-.75-.75h-16.5c-.422 0-.75.375-.75.75v2.25zM14.75 26h4.5c.375 0 .75-.328.75-.75v-4.5c0-.375-.375-.75-.75-.75h-4.5c-.422 0-.75.375-.75.75v4.5c0 .422.328.75.75.75zm3.75-4.5h-3v3h3v-3z","fill":"#586E8C"}})])
          )
        }
      }
    